import { useState, useEffect } from "react";
import { HealthcareDomain } from "@/types/core";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export const useHcDomainList = () => {
  const [domains, setHcDomains] = useState<HealthcareDomain[] | null>([]);
  const [totalDomains, setTotalDomains] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchDomainsList = async () => {
      try {
        const response = await axiosInstance.get("core/healthcare_domains/");

        setHcDomains(response.data.healthcare_domains);
        setTotalDomains(response.data.total_count);
      } catch (err) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDomainsList();
  }, []);

  return { domains, totalDomains, loading, error };
};
